export default "__VITE_ASSET__DiaODamv__"